// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import { dateFilter } from './utils/filters'
import auth from './services/auth'
// 3rd party libs
import VModal from 'vue-js-modal'
// import datePicker from 'vue-bootstrap-datetimepicker'
import Toasted from 'vue-toasted'
import ImageUploader from 'vue-image-upload-resize'
import VueMq from 'vue-mq'

Vue.use(BootstrapVue)
// Vue.use(datePicker)
Vue.use(Toasted, {position: 'top-right', closeOnSwipe: true, iconPack : 'fontawesome', singleton: false})
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, height: 'auto' })
Vue.use(ImageUploader)
Vue.use(VueMq)
// Global server error
Vue.toasted.register('server_error', 'Oops..Server error occurred.', {
  type : 'error',
  icon : 'fa-frown-o'
})
// filter
Vue.filter('date', dateFilter)

Vue.prototype.$hasRole = (module, role) => {
  return auth.hasRole(module, role)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
})
